import React from "react";
require('styles/Loading.scss');

class ImageWithSpanner extends React.Component {
  constructor(props) {
    super(props);
    this.state = { imageStatus: "loading" };
  }

  handleImageLoaded() {
    this.setState({ imageStatus: "loaded" });
  }

  handleImageErrored() {
    this.setState({ imageStatus: "failed to load" });
  }

  render() {
    return (
      <div>
        <img
          style={this.state.imageStatus === 'loading'?{'display':'none'}:{'display':'block'}}
          src={this.props.imageUrl}
          onLoad={this.handleImageLoaded.bind(this)}
          onError={this.handleImageErrored.bind(this)}
        />
        {this.state.imageStatus === 'loading'?(
          <div style={{width:"100%",height:'120px',lineHeight: '120px',background: '#F5F5F5'}}>
            <i className="fa fa-spinner" aria-hidden="true"></i>
          </div>):null}
      </div>
    );
  }
}

ImageWithSpanner.displayName = 'ImageWithSpanner';

export default ImageWithSpanner;


// WEBPACK FOOTER //
// ./src/components/ImageWithSpanner.js